import { render, staticRenderFns } from "./DashboardQueueForPatient.vue?vue&type=template&id=284f5cf6&scoped=true"
import script from "./DashboardQueueForPatient.vue?vue&type=script&lang=js"
export * from "./DashboardQueueForPatient.vue?vue&type=script&lang=js"
import style0 from "./DashboardQueueForPatient.vue?vue&type=style&index=0&id=284f5cf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284f5cf6",
  null
  
)

export default component.exports